import { render, staticRenderFns } from "./AssignmentValidationComment.vue?vue&type=template&id=b87b601c&"
import script from "./AssignmentValidationComment.vue?vue&type=script&lang=js&"
export * from "./AssignmentValidationComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports